export const REALTOR_FORM_LINK_TO_CATALOG = 'realtor_form_link_to_catalog';
export const PHONE_STEP_POSITION = 'realtor_form_phone_step_position';

export const EXPERIMENTS = [REALTOR_FORM_LINK_TO_CATALOG, PHONE_STEP_POSITION];
